/**
 * Given a date (or date string), returns a Date object representing the start
 * of that competition window in Eastern Time—that is, the Monday at 00:00:00.
 *
 * This version uses the browser’s locale conversion via toLocaleString,
 * which avoids issues that can occur when splitting formatted strings.
 */
export const getCompetitionWindowStartForDate = (dateInput) => {
    // Create a Date object from the input.
    const date = new Date(dateInput);
    // Convert the date to Eastern Time by using toLocaleString.
    // This produces a string representation of the date in Eastern locale, then we create a new Date from it.
    const easternDate = new Date(
      date.toLocaleString("en-US", { timeZone: "America/New_York" })
    );
    // Set the time to midnight.
    easternDate.setHours(0, 0, 0, 0);
    // Compute the day of the week (0 for Sunday, 1 for Monday, …, 6 for Saturday).
    const dayOfWeek = easternDate.getDay();
    // Calculate offset so that Monday becomes 0.
    const offset = (dayOfWeek + 6) % 7;
    // Subtract the offset days.
    easternDate.setDate(easternDate.getDate() - offset);
    return easternDate;
  };
  
  /**
   * Given a window start (a Date object representing Monday at 00:00:00 Eastern Time),
   * returns a Date object representing the competition deadline—the following Sunday at
   * 23:59:59.999 Eastern Time.
   */
  export const getCompetitionDeadlineForWindowStart = (windowStart) => {
    const deadline = new Date(windowStart);
    deadline.setDate(deadline.getDate() + 6);
    deadline.setHours(23, 59, 59, 999);
    return deadline;
  };